<div style="margin-top: 20px"></div>

<span id="scrollToTop"></span>
<div #parent id="parent" style="padding: 10px 10px;">     
    <dx-toolbar style="padding-right: 30px;">
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">            
            <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
            (onClick)="exportExcel($event)" [disabled]="childDataGrids.length == 0">
            </dx-button>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
    </dx-toolbar>

    <div style="margin-top: 10px"></div>

    <dx-tab-panel
        #crmChildTabPanel             
        [height]="'auto'"
        [selectedIndex]="0"            
        [loop]="false"
        [animationEnabled]="false"
        [swipeEnabled]="false"
        [deferRendering]="false"            
        [visible]="true">
        <dxi-item [title]="'All Opptys'">
            <div class="heading-box">                    
                <h4 class="heading">{{allOppty_heading1}}</h4>                    
            </div>
            <app-crm-report-datagrid 
                [reportRequest]="reportRequest" 
                [reportType]="'OpptysWith91MA_AllOpptysDetails'"
                (dataGridCreated)="onDataGridCreated($event)">
            </app-crm-report-datagrid>  
        </dxi-item>
        <dxi-item [title]="'Open Opptys'" #OpenOpptyTab>                
            <div class="heading-box">                    
                <h4 class="heading">{{openOppty_heading1}}</h4>                    
            </div>
            <div style="margin-top: 20px;"></div>
            <dx-pivot-grid #OpenOpptyByVol id="OpenOpptyByVol" class="fixMinGridHeight"
                [allowSortingBySummary]="true" [allowFiltering]="false" [dataFieldArea]="'row'"
                [showBorders]="true" [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="false"
                [showColumnTotals]="false" [dataSource]="pivotGrid_OpenOpptyByVol_Datasource"
                (onCellPrepared)="onCellPrepared_openOpptyByVol($event)">
                <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
                <dxo-field-panel
                    [showDataFields]="false"
                    [showRowFields]="true"
                    [showColumnFields]="true"
                    [showFilterFields]="false"
                    [allowFieldDragging]="false"
                    [visible]="true">
                </dxo-field-panel>
                <dxo-scrolling mode="virtual"></dxo-scrolling> 
                <dxo-load-panel [enabled]="false"></dxo-load-panel>                   
            </dx-pivot-grid>                   
            <dx-load-panel #openOppty_loadpanel container="#OpenOpptyTab" shadingColor="rgba(0,0,0,0.4)" 
                [showPane]="true" [shading]="false"></dx-load-panel>
            
            <div *ngIf="showMaps">
                <ng-container *ngFor="let map of mapConfigs; let i = index;">
                    <div style="margin-top: 40px;"></div>                                       
                    <div class="map-container">
                        <div class="map-header">
                            <h5 class="content-block">{{map.displayName}}</h5>                              
                        </div>                       
                        <div id="{{map.viewportDivID}}" class="map-viewport" [class.info-text]="showInfoText"></div>
                        <div style="margin-right: 15px"></div>
                        <div id="{{map.legendDivID}}" class="map-legend" [hidden]="hideLegend_allStages">
                            <b>MTD</b>
                            <hr />
                        </div>
                        <div *ngIf="i == mapConfigs.length - 1 && mapConfigs.length > 1" class="up-btn">
                            <dx-button icon="arrowup" text="Top" (onClick)="scrollToTop()"></dx-button>
                        </div>
                    </div>
                </ng-container>       
            </div>         
            <dxo-load-panel #allstagesMap_loadpanel container="#allstagesMap" shadingColor="rgba(0,0,0,0.4)" 
                [showPane]="true" [shading]="false"></dxo-load-panel>
            <span id="scrollToBottom"></span>                                                
        </dxi-item>                                              
    </dx-tab-panel>
</div>
<dx-load-panel
  #loadPanel
  shadingColor="rgba(230,230,230,0.9)"  
  [(visible)]="loadingPanelVisible"
  [showIndicator]="true"
  [message]="'Exporting...'"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false"
  [width]="'100%'"
  [height]="'100%'"
>
</dx-load-panel>
